export default "__VITE_ASSET__SSQRv7uJ__"